import React, { FC, ReactElement } from 'react'

import './RegisterWrapperCard.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { Link } from 'react-router-dom'
import { routingService } from 'app_services/routingService'

const campusLogo = require('app_assets/images/logos/logo_campus.png')
const logoImage = require('app_assets/images/logos/logo.png')
const isotipo = require('app_assets/images/logos/isotipo.png')

interface IRegisterWrapperCardProps {
  children: ReactElement
  title: string
  hideFooter?: boolean
}

const RegisterWrapperCard: FC<IRegisterWrapperCardProps> = ({
  children,
  title,
  hideFooter
}) => {
  return (
    <div className='register-wrapper-card--layout' style={{ backgroundImage: `url(${isotipo})` }}>
      <div className="register-wrapper-card--icons">
        <img src={logoImage} alt="Logo icon" />
        <img src={campusLogo} alt="Campus icon" />
      </div>
      <TextComponent type="subtitle" color="#7C878E" fontWeight={500}>
        {title}
      </TextComponent>
      {children}
      {!hideFooter && (<div className="register-wrapper-card--footer">
        <Link to="/" >
          <TextComponent textDecoration="underline" fontSize={18}>
            Volver a campus
          </TextComponent>
        </Link>
        <div className='register-wrapper-card--login-text'>
          <TextComponent fontWeight={500}>
            Ya tienes una cuenta
          </TextComponent>
          <Link to={routingService.getSecurePath()}>
            <TextComponent fontSize={18} textDecoration="underline">
              Inicia sesión
            </TextComponent>
          </Link>
        </div>
      </div>)}
    </div>
  )
}

export default RegisterWrapperCard
